import API from "../utils/api";


export const getPartnersApi = async (data) => {
    const response = await API.get('partner/get-all',{params:data});
    return { response };
};

export const addPartnerApi = async data => {
    const response = await API.post('partner/add-partner', data,{'content-type': 'multipart/form-data'});
    return { response };
};

export const getPartnerSettingsApi = async (id) => {
    const response = await API.get('partner/get-settings', { params: { id } });
    return { response };
};

export const updatePartnerOrderApi = async data => {
	const response = await API.post('partner/update-partner-order', data);
	return { response };
};


export const getPartnerApi = async id => {
    const response = await API.get(`partner/${id}/edit`);
    return { response };
};

export const updatePartnerApi = async (data, id)  => {
    const response = await API.post(`partner/${id}/update`, data,{'content-type': 'multipart/form-data'});
    return { response };
};

export const updatePartnerStatusApi = async data => {
	const response = await API.post('partner/update-partner-status', data);
	return { response };
};

export const showPartnerApi = async id => {
    const response = await API.get(`partner/${id}/show`);
    return { response };
};

export const partnerSelectAutoSuggestionApi = async (text) => {
    const response = await API.get('partner/get-customer-details', {
        params: text,
    });
    return { response };
};

export const addPartnerInvoiceDataApi = async data => {
    const isFormData = data instanceof FormData;

    const response = await API.post("partner/invoice-data", data, {
        headers: isFormData
        ? { "Content-Type": "multipart/form-data" }
        : { "Content-Type": "application/json" },
    });

    return {response};
};

export const getPartnersInvoiceDataApi = async (data) => {
    const response = await API.get('partner/invoice-data',{params:data});
    return { response };
};

export const getStatementReconsiliationSettingsApi = async (id) => {
    const response = await API.get('partner/get-reconciliation-settings', { params: { id } });
    return { response };
};

export const getReconciliationDataApi = async (data) => {
    const response = await API.get('partner/invoice-batch',{params:data});
    return { response };
};

export const getReconciliationSummaryApi = async (data) => {
    const response = await API.get('partner/invoice-summary-details',{params:data});
    return { response };
};

export const getReconciliationDetailsApi = async (data, signal) => {
    const response = await API.get('partner/invoice-details',{params:data, signal});
    return { response };
};
export const getUnmatchedDataApi = async (data) => {
    const response = await API.get('partner/invoice-unmatched',{params:data});
    return { response };
};

export const addInvoiceItemDecisionApi = async data => {
    const response = await API.post('partner/invoice-decision', data);
    return { response };
};

export const generateStatementReconciliationDetails = async (data) => {
  const response = await API.get(
    "partner/invoice-csv-export",
    { params: data },
    { "content-type": "application/pdf", responseType: "blob" }
  );
  return { response };
};

export const getMisMatchedDataApi = async (data) => {
    const response = await API.get('partner/mismatch-orders',{params:data});
    return { response };
};

export const generateMismatchDetails = async (data) => {
  const response = await API.post(
    "partner/mismatch-export",
    data,
    { "content-type": "application/pdf", responseType: "blob" }
  );
  return { response };
};

export const emailSendingStatementReconciliationDetailsApi = async (data) => {
  const response = await API.post(
    "partner/email-sending-reconciliation-details",
    data,
  );
  return { response };
};

export const generateAllStatementReconciliationDetails = async (data) => {
  const response = await API.get(
    "partner/all-invoice-csv-export",
    { params: data },
    { "content-type": "application/pdf", responseType: "blob" }
  );
  return { response };
};